import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { FilterCombobox } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/Filter/FilterCombobox';
import {
  STATUS,
  Status,
} from '@/domain/mitarbeiter/features/rotationsplan/features/shared/types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function StatusFilter() {
  const { t } = useTranslation();
  const { store } = useRotationsplanFeatureContext();
  const [selectedStatus, setSelectedStatus] = useState<Status[]>(
    store.ui.uebersicht.filter.status,
  );

  const options = STATUS.map((status) => ({
    value: status,
    label: t(`domain.mitarbeiter.rotationsplan.filter.status.${status}`),
  }));

  function applySelection(newStatus: Status[]) {
    setSelectedStatus(newStatus);
    store.setUebersichtStatusFilter(newStatus);
  }

  return (
    <FilterCombobox
      label={t('domain.mitarbeiter.rotationsplan.filter.status.label')}
      options={options}
      value={selectedStatus}
      onValueChange={(values) =>
        applySelection(STATUS.filter((status) => values.includes(status)))
      }
      onClear={() => applySelection([])}
      searchable={false}
    />
  );
}
